import { useParams } from 'react-router-dom';

import { RouteConfig } from '@Config/routes';

export function useRouteParams<T extends (typeof RouteConfig)[keyof typeof RouteConfig]>(routeConfig: T) {
  type UrlParams = Parameters<(typeof routeConfig)['buildLink']>[0];
  return useParams() as unknown as UrlParams extends Record<string, string> ? UrlParams : Record<string, never>;
}
